<mat-toolbar class="subtitulo">Relatórios de Beneficiários</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formulario="ngForm">

            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>
                <mat-form-field fxFlex="100%" fxFlexOffset="20px">
                    <mat-label>Selecione o tipo do relatório</mat-label>
                    <mat-select required
                                [(ngModel)]="tipoRelatorioSelecionado" 
                                name="tipoRelatorioSelecionado">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let d of tiposRelatorios" [value]="d">
                            {{d.descricao.toUpperCase()}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>
                <div ngModelGroup="comboCpfBeneficiario" fxFlex="250px" fxLayoutGap="20px" fxFlexOffset="20px">
                    <combo-pesquisavel #comboCpfBeneficiario 
                                       nome="cpf" 
                                       [itens]="comboCpf" 
                                       itemDescricao="cpf"
                                       itemId="id"
                                       [showDisplayId]="false" 
                                       [obrigatorio]="false"
                                       placeholder="CPF do beneficiário"
                                       [(valor)]="filtro.cpfAluno">
                    </combo-pesquisavel>
                </div> 

                <mat-form-field fxFlex= "200px" fxLayoutGap="20px" fxFlexOffset="20px">
                    <input matInput name= "dataInicio"
                            [matDatepicker]="dataInicio" 
                            placeholder="Data início instituicao" 
                            [(ngModel)]="filtro.dataInicioInstituicao"
                            (input)="onMascaraDataInput($event)">
                    <mat-datepicker-toggle matSuffix [for]="dataInicio"></mat-datepicker-toggle>
                    <mat-datepicker #dataInicio></mat-datepicker>
                </mat-form-field>
            
                <mat-form-field fxFlex= "200px" >
                    <input matInput name="dataFim"
                            [matDatepicker]="dataFim" 
                            placeholder="Data fim instituicao" 
                            [(ngModel)]="filtro.dataFimInstituicao"
                            (input)="onMascaraDataInput($event)">
                    <mat-datepicker-toggle matSuffix [for]="dataFim"></mat-datepicker-toggle>
                    <mat-datepicker #dataFim></mat-datepicker>
                </mat-form-field>

            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>
                <div ngModelGroup="comboBeneficiario" fxFlex="34" fxLayoutGap="20px">
                    <combo-beneficiario [showDisplayId]="false" 
                                        [obrigatorio]="false" 
                                        [selecionado]="filtro.beneficiario"
                                        (valorChange)="onValorChange($event)">
                    </combo-beneficiario>
                </div>
                
                <div ngModelGroup="comboMaeBeneficiario" fxFlex="33%" fxLayoutGap="20px" fxFlexOffset="20px">
                    <combo-pesquisavel #comboMaeBeneficiario 
                                       nome="maeBeneficiario" 
                                       [itens]="comboMae" 
                                       itemDescricao="nomeMae"
                                       itemId="id"
                                       [showDisplayId]="false" 
                                       [obrigatorio]="false"
                                       placeholder="Mãe do beneficiário"
                                       [(valor)]="filtro.maeAluno">
                    </combo-pesquisavel>
                </div>

                <div ngModelGroup="comboPaiBeneficiario" fxFlex="33%" fxLayoutGap="20px" fxFlexOffset="20px">
                    <combo-pesquisavel #comboPaiBeneficiario 
                                       nome="paiBeneficiario" 
                                       [itens]="comboPai" 
                                       itemDescricao="nomePai"
                                       itemId="id"
                                       [showDisplayId]="false" 
                                       [obrigatorio]="false"
                                       placeholder="Pai do beneficiário"
                                       [(valor)]="filtro.paiAluno">
                    </combo-pesquisavel>
                </div>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" fxFlexFill>   
                <div ngModelGroup="cbPrograma" fxFlex="34" fxLayoutGap="20px">
                    <combo-programa [showDisplayId]="false" #campoPrograma
                                    [obrigatorio]="false" 
                                    [selecionado]="filtro.programa"
                                    (valorChange)="onValorChangePrograma($event)">
                    </combo-programa>
                </div>
                
                <div ngModelGroup="cbProjeto" fxFlex="33%" >
                    <combo-projeto [showDisplayId]="false" #campoProjeto
                                   [obrigatorio]="false" 
                                   [selecionado]="filtro.projeto"
                                   (valorChange)="onValorChangeProjeto($event)">
                    </combo-projeto>
                </div> 

                <div ngModelGroup="cbUnidade" fxFlex="33%" fxFlexOffset="20px">
                    <div ngModelGroup="comboProjeto-" fxFlex="100">
                        <combo-pesquisavel #comboUnidade 
                                            nome="unidade" 
                                            [itens]="comboUnidades" 
                                            itemDescricao="nomeUnidade"
                                            itemId="id"
                                            [showDisplayId]="false" 
                                            placeholder="Unidade"
                                            [obrigatorio]="false"
                                            [(valor)]="filtro.unidade">
                        </combo-pesquisavel>
                    </div>
                </div>
            </div>


            <div dir="rtl" class="botoes" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;" fxFlexFill>
                <button mat-raised-button fxFlex="150px" (click)="getRelatorio(MIMETYPE_PDF)" 
                        [ngStyle]="{'background-color' : formulario.valid ? 'green' : ''}" 
                        style="color: white;" 
                        [fxHide]="!mostrarTabela"
                        [disabled]="formulario.invalid">
                    GERAR PDF
                </button>

                <button mat-raised-button fxFlex="150px" 
                        (click)="getRelatorio(MIMETYPE_EXCEL)" 
                        [ngStyle]="{'background-color' : formulario.valid ? 'green' : ''}" 
                        style="color: white;" 
                        [fxHide]="!mostrarTabela"
                        [disabled]="formulario.invalid">
                    GERAR EXCEL
                </button>

                <button mat-raised-button fxFlex="150px" (click)="consultar()" 
                        [disabled]="formulario.invalid">
                    CONSULTAR
                </button>

                <button mat-raised-button fxFlex="150px" style="padding-right: 20px" (click)="limpar()">
                    LIMPAR
                </button>

                <button mat-raised-button fxFlex="150px" style="padding-right: 20px" 
                        (click)="showEditorRicoDialog(null)" 
                        [fxHide]="!isPossuiTextoObservacao() || !mostrarTabela"
                        [disabled]="formulario.invalid">
                    OBSERVAÇÃO
                </button>

            </div>
        </form>



        <div [hidden]="!mostrarTabela" style="margin-top: 20px;">
            <mat-paginator #paginator [pageSizeOptions]="[50, 100, 150, 200, 300]" showFirstLastButtons></mat-paginator>
        </div>
        <table [fxHide]="!mostrarTabela" 
                matSort matSortDisableClear mat-table [dataSource]="dataSource">
                
            <!-- Checkbox Column -->
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef style="width: 20px">
                    <mat-checkbox (change)="$event ? masterToggle() : null"
                                    [checked]="selection.hasValue() && isAllSelected()"
                                    [indeterminate]="selection.hasValue() && !isAllSelected()">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()"
                                  (change)="$event ? selection.toggle(row) : null"
                                  [checked]="selection.isSelected(row)">
                    </mat-checkbox>
                </td>
            </ng-container>
            
            <ng-container matColumnDef="matricula" >
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 50px">Matrícula</th>
                <td mat-cell *matCellDef="let element"> {{element.matricula }} </td>
            </ng-container>

            <ng-container matColumnDef="beneficiario" >
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 200px">Beneficiário</th>
                <td mat-cell *matCellDef="let element"> {{element.nomeBeneficiario }} </td>
            </ng-container>

            <ng-container matColumnDef="nomeMae">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 200px">Mãe</th>
                <td mat-cell *matCellDef="let element"> {{element.nomeMae }} </td>
            </ng-container>

            <ng-container matColumnDef="nomePai">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 200px">Pai</th>
                <td mat-cell *matCellDef="let element"> {{element.nomePai }} </td>
            </ng-container>

            <ng-container matColumnDef="unidade">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 200px">Unidade</th>
                <td mat-cell *matCellDef="let element"> {{element.unidade }} </td>
            </ng-container>            

            <ng-container matColumnDef="dataEntrada">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="width: 80px"> Data Entrada</th>
                <td mat-cell *matCellDef="let element"> {{element.dataEntrada | dataSimples }} </td>
            </ng-container>

            <ng-container matColumnDef="dataDesligamento">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="width: 80px"> Data Desligamento</th>
                <td mat-cell *matCellDef="let element"> {{element.dataDesligamento | dataSimples }} </td>
            </ng-container>

            <ng-container matColumnDef="acoes">
                <th mat-header-cell *matHeaderCellDef style="width: 30px"> Observação </th>
                <td mat-cell *matCellDef="let element">
                    <button mat-button (click)="showEditorRicoDialog(element); $event.stopPropagation()"
                            [disabled]="!isPossuiTextoObservacao()">
                        <mat-icon>edit</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"></tr>
        </table>
        <div [hidden]="!mostrarTabela">
            <mat-paginator (page)="handlePageBottom($event)" 
                            [pageSize]="paginator.pageSize"
                            [pageIndex]="paginator.pageIndex" 
                            [length]="paginator.length"
                            [pageSizeOptions]="paginator.pageSizeOptions">
            </mat-paginator>
        </div>        
        <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 20px"
                [fxHide]="mostrarTabela" >
            {{msg}}
        </div>       

    </div>
</div>




